declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

const isProduction = process.env.NODE_ENV === 'production';

function fbq(...args: unknown[]) {
  if (!isProduction || typeof window === 'undefined' || !window.fbq) return;
  window.fbq(...args);
}

export function trackMetaPageView() {
  fbq('track', 'PageView');
}

export function trackMetaCompleteRegistration() {
  fbq('track', 'CompleteRegistration', {
    content_name: 'signup',
    status: true,
  });
}
